import { createSlice } from "@reduxjs/toolkit";
import instance from "../../../api/api.js";

export const fectchRecouvrementGlobale = (payload) => async (dispatch) => {
  console.log("fectchRecouvrementGlobale", payload);
  try {
    const data = {
      annee: payload.$y,
    };
    const response_recouvrement_globale = await instance.post(
      "recouvrementProprietesGlobale",
      data
    );
    console.log("response_recouvrement_globale", response_recouvrement_globale);
    dispatch(
      fetch_Statistiques_Recouvrement_Globale({
        data: response_recouvrement_globale.data.data,
      })
    );
  } catch (error) {
    console.log();
  }
};

export const recouvrementGlobaleReducer = createSlice({
  name: "recouvrementGlobale",
  initialState: {
    data_recouvrement: [],
  },
  reducers: {
    fetch_Statistiques_Recouvrement_Globale: (state, action) => {
      return {
        ...state,
        data_recouvrement: action.payload.data,
      };
    },
  },
});

export const { fetch_Statistiques_Recouvrement_Globale } =
  recouvrementGlobaleReducer.actions;
export default recouvrementGlobaleReducer.reducer;
